import { render, staticRenderFns } from "./pro.vue?vue&type=template&id=1232b152"
import script from "./pro.vue?vue&type=script&lang=js"
export * from "./pro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports